import { useEffect } from "react";

// Api
import { transactionsApi } from "redux/transaction/api";

// Components
import TransactionList from "components/molecules/TransactionList";

// Hooks
import { useSelector } from "react-redux";

// Selectors
import * as transactionSelector from "redux/transaction/selectors";
import { TRANSACTION_STATUS } from "types/Transaction";
import { useGTM } from "hooks/useGTM";

const TransactionListDepositContainer = () => {
  const GTM = useGTM();
  const list = useSelector(transactionSelector.transactionListDeposit);
  const sort = useSelector(transactionSelector.transactionSort).id.toString();

  const { isSuccess, refetch } = transactionsApi.useDepositQuery(sort);

  useEffect(() => {
    if (isSuccess) {
      GTM.depositResult(TRANSACTION_STATUS.SUCCESS);
    }
  }, [isSuccess, GTM]);

  useEffect(() => {
    refetch();
  }, [refetch, sort]);

  return <TransactionList list={list} />;
};

export default TransactionListDepositContainer;
